module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/past_light.bdfe4c3d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/past_light.png
// module id = 2869
// module chunks = 11